import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetIndividualsCityReport as GetIndividualsCityReportGenerated,
  GetIndividualsCityReportVariables as GetIndividualsCityReportVariablesGenerated,
} from "core/queries/__generated__/GetIndividualsCityReport";

export interface GetIndividualsCityReportResponse
  extends GetIndividualsCityReportGenerated {}
export interface GetIndividualsCityReportVariables
  extends GetIndividualsCityReportVariablesGenerated {}

const getIndividualsCityReport = gql`
  query GetIndividualsCityReport($filter: TaskMetricsFilterInput!) {
    cityTaskMetrics {
      userMetrics(filters: $filter) {
        metricHeaders {
          label
          tooltip
        }
        metricRows {
          metrics {
            formattedValue
            value
          }
          resource {
            id
            imageUrl
            name
          }
        }
      }
    }
  }
`;

export interface UseGetIndividualsCityReportOptions {
  skip: boolean;
  variables: GetIndividualsCityReportVariables;
}

export const useGetIndividualsCityReportQuery = ({
  skip = false,
  variables,
}: UseGetIndividualsCityReportOptions) =>
  useQuery<GetIndividualsCityReportResponse, GetIndividualsCityReportVariables>(
    getIndividualsCityReport,
    {
      skip,
      variables,
    },
  );
